export default __webpack_public_path__ + "static/media/infra.579ccd5f.png";